import { request } from "./HttpService";
import { ftAccessToken, ftRefreshToken } from "../constants/Constants";
import { refreshToken } from "./AuthService";
import { properties } from "../properties";

export const fetchSampleManuscript = () => request("GET", "/sample/manuscript");

export const fetchSampleTopSimilarPapers = () => request("GET", "/sample/similar/top/papers");

export const fetchSampleSimilarPapers = () => request("GET", "/sample/similar/papers");

export function downloadSampleExportCall(firstCall = true) {
    return new Promise((resolve, reject) => {
        const accessToken = localStorage.getItem(ftAccessToken)?.replaceAll('"', '');
        const xhttp = new XMLHttpRequest();
        xhttp.open("GET", properties.host + "/sample/export/download", true);
        xhttp.responseType = "blob";
        if (accessToken) xhttp.setRequestHeader("Authorization", "Bearer " + accessToken);
        xhttp.onreadystatechange = function () {
            if (this.readyState === 4) {
                if (this.status === 200) {
                    resolve({ blob: xhttp.response, disposition: xhttp.getResponseHeader("Content-Disposition") });
                } else if ((this.status === 401 || this.status === 403) && firstCall) {
                    refreshToken()
                        .then(newToken => {
                            localStorage.setItem(ftAccessToken, JSON.stringify(newToken));
                            downloadSampleExportCall(false).then(resolve).catch(reject);
                        })
                        .catch(() => {
                            localStorage.removeItem(ftAccessToken);
                            localStorage.removeItem(ftRefreshToken);
                            reject(new Error("Failed to refresh token."));
                        });
                } else {
                    reject(new Error("Download failed"));
                }
            }
        };
        xhttp.send();
    });
}
